import {
  useEffect,
  useCallback,
  useState,
  // useMemo,
  // useRef,
} from "react";

import {
  Card,
  // IconButton,
  Grid,
  Divider,
  // Tabs,
  // Tab,
  Box,
  // Typography,
  // useMediaQuery,
} from "@mui/material";

import { useTheme } from "@mui/material/styles";
// import { debounce } from "loadsh";

import DashboardLayout from "./LayoutContainer/DashboardLayout";
import MDBox from "../components/MDBox";
import MDTypography from "../components/MDTypography";
// import RefreshIcon from "@mui/icons-material/Refresh";
import DashboardCard from "../components/DashboardCard";
// import MDInput from "../components/MDInput";
// import SearchField from "../components/SearchField";
// import MDBadge from "../components/MDBadge";

//import DataTable from "../components/DataTable";
import {
  axios,
  consts,
  //regex,
  formatWatt,
  numberFixedFormat,
  //splitIntoChunk,
} from "../common";
import { useAuth } from "../AuthProvider";
import dayjs from "dayjs";
import SolarPowerIcon from "@mui/icons-material/SolarPower";

import AssessmentIcon from "@mui/icons-material/Assessment";
import EnergySavingsLeafIcon from "@mui/icons-material/EnergySavingsLeaf";
// import GridViewIcon from "@mui/icons-material/GridView";
// import TableViewIcon from "@mui/icons-material/TableView";

// import qs from "qs";

import useInterval from "../hooks/useInterval";
import { useTranslation } from "react-i18next";

import DashboardItem from "../components/DashboardItem";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/grid";
import "swiper/css/pagination";

import { ToastContainer, toast } from "react-toastify";

import { Grid as SGrid, Pagination } from "swiper/modules";
import "react-toastify/dist/ReactToastify.css";
// const alarmNames = {
//   solarOvLimit: "태양광 과전압 제한",
//   solarUvLimit: "태양광 저전압 제한",
//   solarOvFault: "태양광 과전압 고장",
//   solarUvFault: "태양광 저전압 고장",
//   lineFailure: "계통 이상",
//   invGroundFault: "인버터 접지 이상",
//   invOcFault: "인버터 과전류 고장",
//   igbtOverCurrent: "IGBT 과전류",
//   dclinkOverVolt: "DC Link 과전압",
//   invMcStatus: "인버터 MC 상태 이상",
//   invFuseStatus: "인버터 Fuse 이상",
//   invOtFault: "인버터 과열 고장",
//   invMcFault: "인버터 MC 고장",
//   invOutvoltFault: "출력 전압 이상",
//   invFrequencyFault: "주파수 이상",
//   lineInvAsyncFault: "계통 인버터 비동기 이상",
//   lineSequencyFault: "상순 이상",
//   lineUvFault: "계통 저전압 이상",
//   lineOvFault: "계통 과전압 이상",
//   lineUfFault: "계통 저주파 이상",
//   lineOfFault: "계통 과주파 이상",
//   invOcOverTimeFault: "인버터 과전류 시간 초과",
// };

const _ = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  const [items, setItems] = useState([]);
  const [totalPower, setTotalPower] = useState(0);
  const [todayTotal, setTodayTotal] = useState(0);
  const [totalCapacity, setTotalCapacity] = useState(0);
  const [totalCo2Reduction, setTotalCo2Reduction] = useState(0);
  const [currentTime, setCurrentTime] = useState(dayjs());
  const [previousAlarms, setPreviousAlarms] = useState([]);

  console.log({ previousAlarms });

  const { user } = useAuth();

  useInterval(() => {
    setCurrentTime(dayjs());
  }, 1000);

  const loadData = useCallback(async (id) => {
    try {
      const { status, data } = await axios.get("/station/dashboard-new", {
        params: { cusNo: id },
      });

      if (status === 200) {
        setTotalPower(data.data.totalPower);
        setTotalCapacity(data.data.totalCapacity);
        setTodayTotal(data.data.todayTotal);
        setTotalCo2Reduction(data.data.totalCo2);

        const stations = data.data.stations || [];

        setPreviousAlarms((prev) => {
          const nextAlarms = {};

          stations.forEach((station) => {
            //console.log({ station });
            const currentAlarmCodes = [
              ...new Set(
                (station.alaramCodes || []).map((item) => item.alertCode),
              ),
            ];

            const previousAlarmCodes = prev[station.id] || [];

            // 최초 데이터
            if (!(station.id in prev)) {
              const message = createAlarmMessage(
                station.stationName,
                station.alaramCodes,
              );

              if (message) {
                // 여기서 알람 표시
                console.log({ message });
                // showAlarm(message);
                toast.warning(message);
              }
            } else {
              // 이후에는 새로 추가된 알람만 찾음
              const newAlarmCodes = currentAlarmCodes.filter(
                (code) => !previousAlarmCodes.includes(code),
              );

              if (newAlarmCodes.length > 0) {
                const newAlarmData = (station.alaramCodes || []).filter(
                  (item) => newAlarmCodes.includes(item.alertCode),
                );

                const message = createAlarmMessage(
                  station.stationName,
                  newAlarmData,
                );

                if (message) {
                  console.log(message);
                  // showAlarm(message);

                  toast.warning(message);
                }
              }
            }

            nextAlarms[station.id] = currentAlarmCodes;
          });

          return nextAlarms;
        });

        setItems((prev) => {
          if (prev.length === 0) {
            return data.data.stations;
          }

          return prev.map((item) => {
            const newItem = data.data.stations.find((x) => x.id === item.id);

            if (newItem) {
              return {
                ...item,
                logDate: newItem.logDate,
                todayTotal: newItem.todayTotal,
                total: newItem.total,
                currentPower: newItem.currentPower,
                statusCode: newItem.statusCode,
              };
            }
            return item;
          });
        });
      }
    } catch (e) {
      console.log({ e });
    }
  }, []);

  useEffect(() => {
    if (user?.id) {
      loadData(user.id);
    }
  }, [loadData, user]);

  useInterval(
    () => {
      if (user?.id) {
        loadData(user.id);
      }
    },
    1000 * 60 * 5,
  ); // 5분마다 데이터 갱신

  // const createAlarmMessage2 = (stationName, alarmData) => {
  //   const trueAlarms = Object.entries(alarmData)
  //     .filter(([key, value]) => value === true)
  //     .map(([key]) => alarmNames[key] || key);

  //   if (trueAlarms.length === 0) {
  //     return;
  //   }

  //   if (trueAlarms.length === 1) {
  //     return `${stationName} 발전소에서 ${trueAlarms[0]} 알람이 발생하였습니다.`;
  //   }

  //   return `${stationName} 발전소에서 ${trueAlarms[0]} 외 ${
  //     trueAlarms.length - 1
  //   }건의 알람이 발생하였습니다.`;
  // };

  // const loadAlarms = useCallback(async (id) => {
  //   try {
  //     const { status, data } = await axios.get("/station/alarams", {
  //       params: { cusNO: id },
  //     });

  //     if (status === 200) {
  //       data.data.forEach((alaram) => {
  //         const message = createAlarmMessage2(alaram.stationName, alaram);
  //         if (message) {
  //           toast.warning(message);
  //         }
  //       });
  //     }
  //   } catch (e) {}
  // }, []);

  // useEffect(() => {
  //   if (user?.id) {
  //     loadAlarms(user.id);
  //   }
  // }, [loadAlarms, user]);

  // useInterval(
  //   () => {
  //     if (user?.id) {
  //       loadAlarms(user.id);
  //     }
  //   },
  //   1000 * 60 * 10,
  // );

  const createAlarmMessage = (stationName, alarmCodes) => {
    if (!alarmCodes || alarmCodes.length === 0) {
      return null;
    }

    const trueAlarms = [...new Set(alarmCodes.map((item) => item.alertCode))];

    console.log({ trueAlarms });
    if (trueAlarms.length === 0) {
      return null;
    }

    // if (trueAlarms.length === 1) {
    //   return `${stationName} 발전소에서 ${
    //     alarmNames[trueAlarms[0]] || trueAlarms[0]
    //   } 알람이 발생하였습니다.`;
    // }

    if (trueAlarms.length === 1) {
      return `${stationName} 발전소에서 ${
        consts.ALARM_CODE.find((f) => f.value === trueAlarms[0])?.label ||
        trueAlarms[0]
      } 알람이 발생하였습니다.`;
    }

    return `${stationName} 발전소에서 ${
      consts.ALARM_CODE.find((f) => f.value === trueAlarms[0])?.label ||
      trueAlarms[0]
    } 외 ${trueAlarms.length - 1}건의 알람이 발생하였습니다.`;

    // return `${stationName} 발전소에서 ${
    //   alarmNames[trueAlarms[0]] || trueAlarms[0]
    // } 외 ${trueAlarms.length - 1}건의 알람이 발생하였습니다.`;
  };

  return (
    <DashboardLayout>
      <MDBox sx={{ maxHeight: "100vh" }}>
        <MDBox py={3}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6} xl={3}>
              <DashboardCard
                icon={<SolarPowerIcon />}
                title={`${formatWatt(totalPower).v} ${
                  formatWatt(totalPower).f
                }`}
                description={t("station.currentPower")}
                //value="10 kW"
              />
            </Grid>
            <Grid item xs={12} md={6} xl={3}>
              <DashboardCard
                icon={<AssessmentIcon />}
                title={`${formatWatt(todayTotal).v} ${
                  formatWatt(todayTotal).f
                }h`}
                description={t("station.todayEnergy")}
                //value="10 kW"
                color="success"
              />
            </Grid>
            <Grid item xs={12} md={6} xl={3}>
              <DashboardCard
                icon={<EnergySavingsLeafIcon />}
                title={`${numberFixedFormat(totalCo2Reduction, 3)} t/CO2`}
                //title={`${numberFixedFormat(totalCo2Reduction, 3)} t/CO2`}
                description={t("station.co2redu")}
                color="primary"
                //value="10 kW"
              />
            </Grid>
            <Grid item xs={12} md={6} xl={3}>
              <Card
                sx={{
                  minHeight: theme.typography.pxToRem(164.5),
                  maxHeight: theme.typography.pxToRem(164.5),
                }}
              >
                <MDBox p={2} mx={3} display="flex" justifyContent="center">
                  <MDBox pb={2} px={2} textAlign="center" lineHeight={1.25}>
                    <MDTypography
                      variant="h5"
                      fontWeight="medium"
                      textTransform="capitalize"
                    >
                      {`${formatWatt(totalCapacity || 0).v} ${
                        formatWatt(totalCapacity || 0).f
                      }p`}
                    </MDTypography>

                    <MDTypography
                      variant="caption"
                      color="text"
                      fontWeight="regular"
                    >
                      {t("station.installCapacity")}
                    </MDTypography>

                    <Divider />

                    <MDTypography variant="h6" fontWeight="medium">
                      {currentTime.format("YYYY-MM-DD HH:mm:ss")}
                    </MDTypography>
                  </MDBox>
                </MDBox>
              </Card>
              {/* <DashboardCard
              icon={<ElectricMeterIcon />}
              title="10 kW"
              description="실시간 발전량"
              //value="10 kW"
            /> */}
            </Grid>
            {/* <Grid item xs={12} md={4} xl={1.5}>
            <DashboardCard
              icon={<ElectricMeterIcon />}
              title="10 kW"
              description="실시간 발전량"
              //value="10 kW"
            />
          </Grid> */}
          </Grid>
        </MDBox>

        <MDBox sx={{}}>
          <Card sx={{ height: "100%" }}>
            <MDBox p={3}>
              {/* <Grid container>
              <Grid item xs={12} md={6} lg={4} xl={3}>
                <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  aria-label="basic tabs example"
                >
                  <Tab
                    label="대시보드 뷰"
                    icon={<GridViewIcon />}
                    {...a11yProps(0)}
                  />
                  <Tab
                    label="테이블 뷰"
                    icon={<TableViewIcon />}
                    {...a11yProps(1)}
                  />
                </Tabs>
              </Grid>
            </Grid>
            <Divider /> */}

              <Box
                sx={{
                  "& .swiper": {
                    width: "100%",
                    height: "100%",
                    marginLeft: "auto",
                    marginRight: "auto",
                    //background: "blue",
                    //padding: 20,
                    paddingTop: 2,
                    paddingLeft: 1,
                    paddingRight: 1,
                    paddingBottom: 10,
                  },

                  // "& .swiper-slide": {
                  //   width: "100%",
                  //   display: "grid !important",
                  //   gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr ",
                  //   gridTemplateRows: "1fr 1fr 1fr",
                  //   gap: "10px, 10px",
                  // },

                  "& .swiper-slide": {
                    textAlign: "center",
                    fontSize: "18px",
                    //background: "red",
                    height: "calc((100% - 30px) / 2) !important",

                    /* Center slide text vertically */
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  },
                }}
              >
                <Swiper
                  slidesPerView={1}
                  spaceBetween={10}
                  grid={{
                    rows: 3,
                    fill: "row",
                  }}
                  pagination={{
                    dynamicBullets: true,

                    clickable: true,
                  }}
                  breakpoints={{
                    390: {
                      slidesPerView: 1,
                      spaceBetween: 10,
                    },

                    576: {
                      slidesPerView: 1,
                      spaceBetween: 10,
                    },
                    768: {
                      slidesPerView: 2,
                      spaceBetween: 10,
                    },
                    930: {
                      slidesPerView: 3,
                      spaceBetween: 10,
                    },

                    1300: {
                      slidesPerView: 3,
                      spaceBetween: 10,
                    },

                    1500: {
                      slidesPerView: 3,
                      spaceBetween: 10,
                    },

                    // 1600: {
                    //   slidesPerView: Math.ceil((1600 - 274) / 350),
                    //   spaceBetween: 10,
                    // },

                    1800: {
                      slidesPerView: 4,
                      spaceBetween: 10,
                    },

                    2000: {
                      slidesPerView: 5,
                      spaceBetween: 10,
                    },

                    2500: {
                      slidesPerView: 6,
                      spaceBetween: 10,
                    },

                    3000: {
                      slidesPerView: 8,
                      spaceBetween: 10,
                    },
                  }}
                  modules={[SGrid, Pagination]}
                  className="mySwiper"
                >
                  {items.map((item) => (
                    <SwiperSlide key={item.stationNo}>
                      <DashboardItem
                        title={item.stationName}
                        invCapacity={item.capacity}
                        invPower={item.currentPower}
                        todayTotal={item.todayTotal}
                        total={item.total}
                        lastedLogDate={item.logDate}
                        statusCode={item.statusCode}
                      />
                    </SwiperSlide>
                  ))}

                  {/* {data?.stations.map((item) => (
                    <SwiperSlide key={item.stationNo}>
                      <DashboardItem
                        title={item.stationName}
                        invCapacity={item.invCapacity}
                        invPower={item.invPower}
                        todayTotal={item.todayTotal}
                        co2Reduction={item.co2Reduction}
                        lastedLogDate={item.lastedLogDate}
                        statusCode={item.statusCode}
                        isLoading={isLoading}
                        monthlySum={item.monthlySum}
                      />
                    </SwiperSlide>
                  ))} */}
                </Swiper>
              </Box>

              {/* <DashboardItem title="광현" /> */}

              {/* <MDBox position="relative" borderRadius="lg">
                <MDBox
                  component="img"
                  // src={image}
                  // alt={title}
                  borderRadius="lg"
                  shadow="md"
                  width="100%"
                  height="100%"
                  position="relative"
                  zIndex={1}
                />
                <MDBox
                  borderRadius="lg"
                  shadow="md"
                  width="100%"
                  height="100%"
                  position="absolute"
                  left={0}
                  top="3%"
                  sx={{
                    // backgroundImage: `url(${image})`,
                    transform: "scale(0.94)",
                    filter: "blur(12px)",
                    backgroundSize: "cover",
                  }}
                />
              </MDBox>
              <MDBox p={3}>
                <MDTypography
                  display="inline"
                  variant="h3"
                  textTransform="capitalize"
                  fontWeight="bold"
                >
                  abc
                </MDTypography>
                <MDBox mt={2} mb={3}>
                  <MDTypography variant="body2" component="p" color="text">
                    1234
                  </MDTypography>
                </MDBox>
              
              </MDBox> */}

              {/* <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                  >
                    <Tab
                      label="대시보드 뷰"
                      icon={<GridViewIcon />}
                      {...a11yProps(0)}
                    />
                    <Tab
                      label="테이블 뷰"
                      icon={<TableViewIcon />}
                      {...a11yProps(1)}
                    />
                  </Tabs>
                </Box>
              </Grid>
              <Grid item xs={12} md={4} lg={3} xl={3}>
                <SearchField />
              </Grid>
              <Divider />
            </Grid> */}
            </MDBox>
          </Card>
        </MDBox>
      </MDBox>

      {/* <MDBox>
        <MDBox sx={{ backgroundColor: "#fff", borderRadius: 1 }} p={1}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} xl={6}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab
                    label="대시보드 뷰"
                    icon={<GridViewIcon />}
                    {...a11yProps(0)}
                  />
                  <Tab
                    label="테이블 뷰"
                    icon={<TableViewIcon />}
                    {...a11yProps(1)}
                  />
                </Tabs>
              </Box>
            </Grid>
            <Grid item xs={12} md={6} xl={6}>
              <SearchField />
            </Grid>
          </Grid>
        </MDBox>

        <CustomTabPanel value={value} index={0}>
          Item One
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          Item Two
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          Item Three
        </CustomTabPanel>
      </MDBox> */}

      <ToastContainer />
    </DashboardLayout>
  );
};

export default _;

// function CustomTabPanel(props) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`simple-tabpanel-${index}`}
//       aria-labelledby={`simple-tab-${index}`}
//       {...other}
//     >
//       {value === index && (
//         <Box sx={{ p: 3 }}>
//           <Typography>{children}</Typography>
//         </Box>
//       )}
//     </div>
//   );
// }

// function a11yProps(index) {
//   return {
//     id: `simple-tab-${index}`,
//     "aria-controls": `simple-tabpanel-${index}`,
//   };
// }
